export default "__VITE_ASSET__D8uherHc__"